import React from "react";

import Header from "../Components/Header";
import Left_Intro from "../Components/Left_Intro";
import Right_Pannel from "../Components/Right_Pannel";
import About_Us from "../Components/About_Us";
import Education from "../Components/Education";
import Experience from "../Components/Experience";
import Certificate from "../Components/Certificate";

function About() {
  return (
    <>
      {/* SEO META TAGS */}
     
        <title>About Akshat Srivastava | Full Stack & React Developer</title>

        <meta
          name="description"
          content="Learn more about Akshat Srivastava, a Full Stack & React Developer with experience in scalable systems, modern UI development, and cloud technologies."
        />

        <meta
          name="keywords"
          content="About Akshat Srivastava, React Developer, Full Stack Developer, Experience, Education"
        />

        <link
          rel="canonical"
          href="https://akshat-srivastava-navy.vercel.app/about"
        />

        {/* Open Graph */}
        <meta property="og:title" content="About Akshat Srivastava" />
        <meta
          property="og:description"
          content="Experience, education, and background of Akshat Srivastava, Full Stack & React Developer."
        />
        <meta
          property="og:url"
          content="https://akshat-srivastava-navy.vercel.app/about"
        />
        <meta property="og:type" content="profile" />
      

      {/* UI - UNCHANGED */}
      <div className="bg-default">
        <Header />

        <div className="md:flex md:px-28">
          <Left_Intro />
          <div className="flex-1 w-full overflow-hidden">
            <About_Us />
            <Experience />
            <Education />
            <Certificate />
          </div>
          <div className="hidden sticky md:block">
            <Right_Pannel />
          </div>
        </div>

        <div className="block md:hidden">
          <Right_Pannel />
        </div>
      </div>
    </>
  );
}

export default About;
